"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
exports.default = () => {
    return new Promise((_, reject) => {
        setTimeout(() => {
            reject(new exception_1.NetworkException("Request timed out"));
        }, 1000);
    });
};
//# sourceMappingURL=timeOutResponseFactory.js.map